import { jsx as c } from "react/jsx-runtime";
import m from "@mui/material/SvgIcon";
import * as e from "react";
import { forwardRef as l } from "react";
const a = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "6 6 20 20", ...t }, /* @__PURE__ */ e.createElement("path", { fill: "currentColor", d: "m16.002 22.756 4.849 3.062c.885.558 1.976-.271 1.741-1.324l-1.287-5.771 4.29-3.888c.78-.707.364-2.048-.665-2.141l-5.646-.51-2.207-5.44a1.149 1.149 0 0 0-2.15 0l-2.208 5.44-5.65.51c-1.028.093-1.444 1.433-.665 2.14l4.282 3.889-1.28 5.775c-.233 1.052.858 1.88 1.742 1.322z" })), f = /* @__PURE__ */ l(({ size: t = "inherit", sx: o, ...r }, i) => {
  const n = typeof o == "function" ? o : {
    fontSize: t,
    ...o
  };
  return /* @__PURE__ */ c(m, {
    ...r,
    ref: i,
    component: a,
    inheritViewBox: !0,
    sx: n
  });
});
f.displayName = "svg_favorite";
export {
  f as default
};
